import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FieldBase from './FieldBase';

export default class TextField extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    submitted: PropTypes.bool,
    value: PropTypes.string,
    isEmail: PropTypes.bool,
    isPhone: PropTypes.bool,
  };

  static defaultProps = {
    value: '',
  };

  textChanged = e => {
    const newText = e.target.value;
    this.props.onChange(newText);
  };

  render() {
    return (
      <FieldBase {...this.props}>
        <input
          onChange={this.textChanged}
          type={this.props.isEmail ? 'email' : this.props.isPhone ? 'tel' : 'text'}
          className={'input ' + (this.props.required && this.props.submitted && this.props.value === '' ? 'error' : '')}
          value={this.props.value}
        />
      </FieldBase>
    );
  }
}
